module.exports = __webpack_public_path__ + "static/media/title_firstam.da7a820d.svg";